import { useHasAppliedTrade } from '~/context/srp/SearchContext';

export default function LoadingTerms() {
  const hasAppliedTrade = useHasAppliedTrade();

  return (
    <div className="animate-pulse">
      {hasAppliedTrade ? 'Applying' : 'Removing'} trade...
    </div>
  );
}
